import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../../style/constants';

const useStyles = makeStyles(() => ({
  wrapper: {
    background: colors.LIGHT_GREY,
  },
  container: {
    position: 'relative',
    '& > div': {
      animation: 'fadeOutIn 20s ease-in-out infinite',
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center'
    },
    '& > h2': {
      animation: 'fadeInOut 20s ease-in-out infinite'
    },
  },
}));

const Catchphrase = (props) => {
  const classes = useStyles();
  return (
    <section className={classes.wrapper + " clipped"}>
      <Container className={classes.container}>
        <h2>{props.catchphrase1}</h2>
        <Container>
          <h2>{props.catchphrase2}</h2> 
        </Container>
      </Container>
    </section>
  );
}

export default Catchphrase;